const LastUpdates = (props) => {
	const { project, name, completed, due_on } = props.task
	const date = due_on ? due_on.split('-').reverse().join('-') : 'Sem Prazo'
	return (
		<div className="updatesField">
			<div className="field">
				<label className="label">Nome do caso:</label>
				<span className="updatesContent">{project}</span>
			</div>
			<div className="field">
				<label className="label">Assunto:</label>
				<span className="updatesContent">{name}</span>
			</div>
			<div className="field">
				<label className="label">Prazo:</label>
				<span className="updatesContent">{date}</span>
			</div>
			<div className="field">
				<label className="label">Status:</label>
				<span className="updatesContent">{completed ? 'Concluído' : 'Em Andamento'}</span>
			</div>
		</div>
	)
}

export default LastUpdates
